import { useEffect, useState } from 'react';
import { C, FONTS } from '../../tokens/design';

export default function BrandLogo({
  src,
  alt = 'Logo',
  letter = 'S',
  primaryColor = '#1a1a2e',
  secondaryColor = '#e94560',
  maxWidth = 180,
  maxHeight = 56,
  width = '100%',
  height = maxHeight,
  frame = false,
  frameColor,
  style,
  imgStyle,
  fallbackStyle,
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [src]);

  const hasLogo = Boolean(src) && !failed;
  const boxStyle = {
    width,
    maxWidth,
    height,
    maxHeight,
    minWidth: 0,
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    overflow: 'hidden',
    flexShrink: 0,
    borderRadius: frame ? 8 : 0,
    background: frame ? (frameColor || 'rgba(255,255,255,0.04)') : 'transparent',
    border: frame ? `1px solid ${C.b1}` : '0',
    padding: frame ? 8 : 0,
    ...style,
  };

  if (hasLogo) {
    return (
      <span style={boxStyle}>
        <img
          src={src}
          alt={alt}
          onError={() => setFailed(true)}
          style={{
            display: 'block',
            width: '100%',
            height: '100%',
            maxWidth: '100%',
            maxHeight: '100%',
            objectFit: 'contain',
            objectPosition: 'center',
            ...imgStyle,
          }}
        />
      </span>
    );
  }

  return (
    <span
      aria-label={alt}
      role="img"
      style={{
        ...boxStyle,
        width: typeof width === 'number' ? width : 38,
        height: typeof height === 'number' ? height : 38,
        borderRadius: 8,
        background: `linear-gradient(135deg, ${primaryColor}, ${secondaryColor})`,
        color: '#fff',
        fontSize: 16,
        fontWeight: 900,
        fontFamily: FONTS.sans,
        ...fallbackStyle,
      }}
    >
      {(letter || 'S').slice(0, 1).toUpperCase()}
    </span>
  );
}
